import { render, staticRenderFns } from "./AccountListAddNew.vue?vue&type=template&id=5b8ac4b2"
import script from "./AccountListAddNew.vue?vue&type=script&lang=js"
export * from "./AccountListAddNew.vue?vue&type=script&lang=js"
import style0 from "./AccountListAddNew.vue?vue&type=style&index=0&id=5b8ac4b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports